import type { VulnAnnotationJustification } from './vulnerability-annotations.models';

export const VULNERABILITY_ANNOTATION_JUSTIFICATIONS = {
  ComponentNotPresent: 'component_not_present',
  VulnerableCodeNotPresent: 'vulnerable_code_not_present',
  VulnerableCodeNotInExecutePath: 'vulnerable_code_not_in_execute_path',
  VulnerableCodeCannotBeControlledByAdversary:
    'vulnerable_code_cannot_be_controlled_by_adversary',
  InlineMitigationsAlreadyExist: 'inline_mitigations_already_exist',
  FixNotPlanned: 'fix_not_planned',
} satisfies Record<string, VulnAnnotationJustification>;

export const VULNERABILITY_ANNOTATION_JUSTIFICATIONS_VALUES = Object.values(
  VULNERABILITY_ANNOTATION_JUSTIFICATIONS,
);
